// extracted by mini-css-extract-plugin
module.exports = {"featuredImage":"styles_featuredImage__ZvP2_","featuredImageContent":"styles_featuredImageContent__9mo5s"};